Vue.component("user-permissions", {
    props: ["user", "teamPortfolios", "permissions", "teamMailboxes", "canChangePermissions"],
    data () {
        return {
            allPortfolios: [],
            allMailboxes: [],
            userPermissions: [],
            isLoading: false
        };
    },
    computed: {
        labelForPortfolios () {
            return this.isOwnProfile() ? "Your Portfolios" : this.user.first_name + "'s Portfolios";
        },
        labelForPermissions () {
            return this.isSuperUser() ? "As " + (this.user.role.match("^[aieouAIEOU].*") ? "an " : "a ") //check if the user role starts with a vowel
                + this.user.role + ", " + (this.isOwnProfile()? "you have " : this.user.first_name + " has ") + "all the permissions."
                :(this.isOwnProfile()? "You have " :  this.user.first_name + " has ") + "the following permissions"; //not a super user
        },
        canChangePortfolios () {
            return this.userCan("manage-users");
        },
        canChangeMailboxes () {
            return this.userCan("manage-mailboxes");
        },
        defaultMailbox () {
            return this.user.default_mailbox_id;
        }
    },
    methods: {
        isOwnProfile () {
            return this.user.id === this.app.userId;
        },
        isSuperUser () {
            if (["Account Owner", "Manager"].indexOf(this.user.role) !== -1) {
                return true;
            }
        },
        teamPortfoliosWithUserAccess () {
            let portfolios = [];
            let self = this;
            this.teamPortfolios.forEach((teamPortfolio) => {

                var canAccessPortfolio = false;
                if (self.user.portfolios.find(function (portfolio) {
                    return portfolio.id === teamPortfolio.id;
                })) {
                    canAccessPortfolio = true;
                }

                portfolios.push({
                    id: teamPortfolio.id,
                    name: teamPortfolio.name,
                    user_can_view: canAccessPortfolio
                });

            });

            return portfolios;
        },
        mailboxesWithUserAccess () {
            let self = this;
            let mailboxes = [];
            this.teamMailboxes.forEach((teamMailbox) => {

                let canAccessMailbox = false;
                if (self.user.mailboxes.find(function (mailbox) {
                    return mailbox.id === teamMailbox.id;
                })) {
                    canAccessMailbox = true;
                }

                mailboxes.push({
                    id: teamMailbox.id,
                    name: teamMailbox.name,
                    email: teamMailbox.email,
                    status: teamMailbox.status,
                    user_can_access: canAccessMailbox
                });

            });

            return mailboxes;
        },
        portfolioAccessChanged (portfolio) {
            axios.post("/settings/portfolios/" + portfolio.id + "/users/" + this.user.id + "/update", {
                _method: "POST",
                user_can_view: portfolio.user_can_view
            })
            .then(() => {
                let name = this.isOwnProfile() ? "You" : this.user.first_name;
                let successMessage = portfolio.user_can_view ?
                    name + " can now access the " + portfolio.name + " portfolio!" :
                    name + " won't be able to view the " + portfolio.name + " portfolio anymore!";
                toastr.success(successMessage);
            })
            .catch(errors => {
                toastr.error("Error updating portfolio access. " + errors.message);
                portfolio.user_can_view = !portfolio.user_can_view;
            });

        },
        mailboxAccessChanged (mailbox) {
            axios.post("/settings/mailboxes/" + mailbox.id + "/users/" + this.user.id + "/update", {
                _method: "POST",
                user_can_access: mailbox.user_can_access
            })
            .then(() => {
                let name = this.isOwnProfile() ? "You" : this.user.first_name;
                let successMessage = mailbox.user_can_access ?
                    name + " can now access the " + mailbox.name + " mailbox!" :
                    name + " won't be able to view the " + mailbox.name + " mailbox anymore.";

                toastr.success(successMessage);

                if (mailbox.user_can_access) {
                    this.user.mailboxes.push(mailbox);
                } else {
                    const index = this.user.mailboxes.findIndex(m => m.id === mailbox.id);
                    if (index !== -1) {
                        this.user.mailboxes.splice(index, 1);
                    }
                }
            })
            .catch(errors => {
                toastr.error("Error updating mailbox access. " + errors.message);
                mailbox.user_can_access = !mailbox.user_can_access;
            });
        },
        savePermissions () {
            this.isLoading = true;
            axios.post("/users/profile/" + this.user.id + "/permissions/update", {
                _method: "PATCH",
                permissions: this.userPermissions
            })
            .then((response) => {
                this.isLoading = false;
                this.userPermissions = response.data;
                toastr.success("Permissions Saved!");
            })
            .catch(errors => {
                this.isLoading = false;
                toastr.error("Could not save permissions. " + errors.message);
            });
        }
    },
    created () {
        let self = this;
        Bus.$on("permissions-changed", function (permissions) {
            self.userPermissions = permissions;
        });
    },
    mounted () {
        this.allPortfolios = this.teamPortfoliosWithUserAccess();
        this.allMailboxes = this.mailboxesWithUserAccess();
        this.userPermissions = this.permissions;
    }
});

